module.exports = __webpack_public_path__ + "img/sc.14258f55.png";